export enum MutationTypes {
    SET_PAYMENT_LIST = 'SET_PAYMENT_LIST',
    SET_PAYMENT_DETAIL = 'SET_PAYMENT_DETAIL',
    SET_PAYMENT_SOUKI_DETAIL = 'SET_PAYMENT_SOUKI_DETAIL',
}
